export matchSort = (text, sortField)->
  value = "#{text}".toUpperCase().trim()
  (a, b) ->
    x = a
    y = b
    if sortField
      x = x[sortField]
      y = y[sortField]
    x = "#{x}".toUpperCase().trim()
    y = "#{y}".toUpperCase().trim()
    xWords = x.match(/\b(\w+)\b/g) || []
    yWords = y.match(/\b(\w+)\b/g) || []

    # look for search value to be an exact match
    return 1 if value is x # choose a
    return -1 if value is y # choose b
    # look for search value to be one of the words
    if xWords.includes(value) and yWords.includes(value)
      if xWords.indexOf(value) > yWords.indexOf(value)
        return 1 # search value shows up in a first
      else
        return -1
    return -1 if xWords.includes value
    return 1 if yWords.includes value

    # look for search value to be a substring
    if x.includes(value) and y.includes(value)
      if xWords.indexOf(value) > yWords.indexOf(value) 
        return 1 # search value shows up in a first
      else
        return -1
    return -1 if x.includes value
    return 1 if y.includes(value)

    # match alphabetically (psudo distance)
    return 1 if value > x and x > y # choose a
    return -1 if value < y and y > x # choose b
    return -1 if value < x and value > y # choose a
    return -1 if value > x and value < y # choose b
    return 1 if x.indexOf(value) > y.indexOf(value)
    return -1 if y.indexOf(value) > x.indexOf(value)
    return x > y

export matchLocationTypeSort = (text, sortField)->
  value = "#{text}".toUpperCase().trim()

  # (a, b) ->
  #   if a.type is 'US State'
  #     return -1
  #   if a.type is 'DMA' and b.type is 'City'
  #     return -1
  #   if a.type is 'DMA' and b.type is 'US State'
  #     return 1
  #   if a.type is 'City'
  #     return 1
  #   return 0

  (a, b) ->
    x = a
    y = b
    if sortField
      x = x[sortField]
      y = y[sortField]
    x = "#{x}".toUpperCase().trim()
    y = "#{y}".toUpperCase().trim()
    xWords = x.match(/\b(\w+)\b/g) || []
    yWords = y.match(/\b(\w+)\b/g) || []

    # look for search value to be an exact match
    return 1 if value is x # choose a
    return -1 if value is y # choose b
    # look for search value to be one of the words
    if xWords.includes(value) and yWords.includes(value)
      if xWords.indexOf(value) > yWords.indexOf(value)
        return 1 # search value shows up in a first
      else
        return -1
    return -1 if xWords.includes value
    return 1 if yWords.includes value

    # look for search value to be a substring
    if x.includes(value) and y.includes(value)
      if xWords.indexOf(value) > yWords.indexOf(value) 
        return 1 # search value shows up in a first
      else
        return -1
    return -1 if x.includes value
    return 1 if y.includes(value)

    # match alphabetically (psudo distance)
    return 1 if value > x and x > y # choose a
    return -1 if value < y and y > x # choose b
    return -1 if value < x and value > y # choose a
    return -1 if value > x and value < y # choose b
    return 1 if x.indexOf(value) > y.indexOf(value)
    return -1 if y.indexOf(value) > x.indexOf(value)
    return x > y

export elementUIOptionsSort = (list, priority=[], idField="id")->
  optionSortFn = (a,b)->
    x = a?[idField] || a
    y = b?[idField] || b
    if x > y then 1 else -1

  orderedOptionSortFn = (a,b)->
    x = priority.indexOf(a?[idField] || a)
    y = priority.indexOf(b?[idField] || b)
    x = priority.length + 1 if -1 is x
    y = priority.length + 1 if -1 is y
    if x > y then 1 else -1

  top = list.filter (item)-> priority.includes (item?[idField] || item) # priority options
  rest = list.filter (item)-> not priority.includes (item?[idField] || item) # non priority options
  top = top.sort orderedOptionSortFn
  rest = rest.sort optionSortFn
  [...top, ...rest]

export default { matchSort, elementUIOptionsSort}
